import { Box, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

export const ScrollTopButton = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 30,
        right: 30,
        backgroundColor: theme.palette.primary.dark,
        borderRadius: "50%",
        width: 50,
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 1000,
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      }}
    >
      <Icon
        icon="ic:round-arrow-upward"
        color={theme.palette.common.white}
        width={28}
        height={28}
      />
    </Box>
  );
};
